import { throttle } from 'lodash';
import JQueryView, { on } from '../../../common/views/jqueryView';

// キャンペーンのフローティングバナー（shared/_campaign_floating_banner）。
// 一定量スクロールしたら表示し、× で閉じる。閉じた記録は持たず、ページを開き直せば再び表示する。
export default class CampaignFloatingBannerView extends JQueryView {
  private static readonly SCROLL_SHOW_OFFSET = 150;
  private static readonly SCROLL_EVENT = 'scroll.campaignFloatingBanner';

  constructor() {
    super('.js-campaign-floating-banner');

    if (this.$el.length === 0) {
      return;
    }

    const handleScroll = () => {
      if (window.scrollY < CampaignFloatingBannerView.SCROLL_SHOW_OFFSET) {
        return;
      }
      this.$el.addClass('is-visible');
      this.stopWatchingScroll();
    };

    $(window).on(
      CampaignFloatingBannerView.SCROLL_EVENT,
      throttle(handleScroll, 100),
    );
    // 戻る操作などでスクロール位置が復元された状態で初期化されたときのため、一度判定しておく
    handleScroll();

    // Turbo はこの時点の DOM をキャッシュする。表示状態のまま残すと、
    // 戻ってきたときにスクロール前でもバナーが見えてしまうため初期状態に戻す
    document.addEventListener(
      'turbo:before-cache',
      () => {
        this.$el.removeClass('is-visible');
        this.stopWatchingScroll();
      },
      { once: true },
    );
  }

  @on({ event: 'click', selector: '.js-campaign-floating-banner-close' })
  handleClose() {
    this.$el.removeClass('is-visible');
    this.stopWatchingScroll();
  }

  private stopWatchingScroll() {
    $(window).off(CampaignFloatingBannerView.SCROLL_EVENT);
  }
}
